import * as React from "react"
import {useEffect} from "react";
import {TagFieldSeeker} from "@ui-seeker/core";

import {useRepricingFormData} from "../../@hooks";
import {disabledEmail} from "../../../@signals";


export default function RepricingFormEmailsTagField() {
	const { emails, handleChangeValue } = useRepricingFormData()

	if (!!disabledEmail.value)
		return <></>

    return <TagFieldSeeker
		label="Notifications to: (Please press Enter to add an email)"
		placeholder="Insert E-Mails"
		value={emails}
		onChange={e => handleChangeValue('email', e)}
	/>
}